// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__zkOqE","content":"ErrorPage_content__T2EMQ","intro":"ErrorPage_intro__waEAU","detail":"ErrorPage_detail__dKj4N"};